import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type MyInfoSettingSpecFragment = (
  { __typename: 'MyInfoSetting' }
  & Pick<SchemaTypes.MyInfoSetting, 'id' | 'displayName' | 'version' | 'isTestEnvironment' | 'baseUrl' | 'clientId' | 'clientSecret' | 'requestPurpose' | 'privateKey' | 'publicCertificate' | 'pkiSignature'>
);

export const MyInfoSettingSpecFragmentDoc = /*#__PURE__*/ gql`
    fragment MyInfoSettingSpec on MyInfoSetting {
  id
  displayName
  version
  isTestEnvironment
  baseUrl
  clientId
  clientSecret
  requestPurpose
  privateKey
  publicCertificate
  pkiSignature
}
    `;